import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Thumb = styled.div`
  margin-bottom: 20px;
`

export const ThumbImageWrapper = styled.div`
  width: 110px;
  height: 94px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${theme.border.mediumRadius};
  border: 1px dashed ${theme.colors.blue};

  object-fit: contain;
  overflow: hidden;
`

export const ThumbImage = styled.img`
  object-fit: contain;
  height: 100%;
`

export const Upload = styled.form`
  margin-left: 25px;

  & > span {
    font-size: ${theme.font.sizes.xxsmall};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.black};
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & > div > label {
    padding: 6px 12px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: ${theme.font.sizes.small};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.blackLight};

    cursor: pointer;
    background: ${theme.colors.white};
    border-radius: ${theme.border.xsmallRadius};
    border: 1px solid #BABABA;
  }

  & > div > input {
    display: none;
  }
`

export const NameWrapper = styled.div`
  height: 32px;

  display: flex;
  align-items: center;
  gap: 15px;

  & > p {
    overflow: hidden;
    max-width: 200px;

    font-size: ${theme.font.sizes.small};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.blackLight};
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & > button {
    background: none;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px !important;
  align-items: flex-start !important;

  & > span {
    font-size: ${theme.font.sizes.xxsmall};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.black};
  }
`
